import { useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';

import { HandTypeTranslations } from '@swf/poker';

import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';
import type { FormValues } from '../utils/common';

const useGetDefaultName = () => {
  const { formatMessage } = useIntl();
  const {
    state: { clubName }
  } = useContext(CreateTournamentContext);

  return useCallback(
    (handType: FormValues['handType']) => {
      const handTypeValue = typeof handType === 'string' && JSON.parse(handType);

      return handTypeValue
        ? `${clubName} - ${formatMessage(HandTypeTranslations[handTypeValue.handType])}`
        : `${clubName} - ${formatMessage(HandTypeTranslations.HT_HOLDEM)}`;
    },
    [clubName, formatMessage]
  );
};

export default useGetDefaultName;
